function getRowLinkProps(_ref) {
  var getRowLink = _ref.getRowLink,
      data = _ref.data,
      isSubRow = _ref.isSubRow;
  return getRowLink ? {
    href: getRowLink(data, isSubRow)
  } : {};
}

export default getRowLinkProps;